import *  as React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import { RouteComponentProps, withRouter } from 'react-router';
import { DialogFooter } from '@fluentui/react/lib/Dialog';
import { Spinner } from '@fluentui/react/lib/Spinner';
import { IUserState } from '../../store/reducers/userReducer';
import { actionCreators } from '../../store/actions/userActions';
import { IAppState } from '../../store';
import '../../assets/css/fabricui.css';
import UtilityService, { IComboBoxItem } from '../../common/UtilityService';
import 'react-times/css/material/default.css';
import { IIconProps } from '@fluentui/react/lib/Icon';
import { Shimmer, ShimmerElementType } from '@fluentui/react/lib/Shimmer';
import { mergeStyles } from '@fluentui/react/lib/Styling';
import { ThemeProvider } from '@fluentui/react/lib/Theme';
import IdentityService from '../../services/membership/Identity.service';
import { MuiMessageBarType, enumFormsStatus, enumStorageType } from '../../enums';
import LoadingSpinner from '../loadingSpinner_dot';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Draggable from 'react-draggable';
import Paper, { PaperProps } from '@mui/material/Paper/Paper';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@material-ui//icons/Close';
import FullscreenIcon from '@material-ui//icons/Fullscreen';
import FullscreenExitIcon from '@material-ui//icons/FullscreenExit';
import { Edit, Delete } from '@material-ui/icons';
import { ResizableBox } from 'react-resizable';
import { createFilterOptions } from '@mui/material/Autocomplete';
import { Box, Checkbox, Tooltip } from '@material-ui/core';
import MaterialReactTable from 'material-react-table';
import { MRT_Localization_FA } from 'material-react-table/locales/fa';
import TextField from '@mui/material/TextField';
import momentJalaali from 'moment-jalaali';
import '../../assets/css/react-resizable.css'
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import appConfigs from '../../config.json';
import { Button } from '@material-ui/core';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertColor, AlertProps } from '@mui/material/Alert';
import { MessagePossition } from '../../services/core/configuration.service';
import Select from '@mui/material/Select';
import { MenuItem } from '@mui/material';
import { IFileItem } from '../../services/cms/file.service';
import { LinearProgress } from '@material-ui/core';
import previewIcon from '../../assets/img/icons8-preview-file-64.png';
import dalService, { IArtworkGridRowItem } from '../../services/CMSApp/Artwork.service';
import eventService, { IEventItem } from '../../services/CMSApp/Event.service';
import RemoveRedEyeOutlinedIcon from '@material-ui/icons/RemoveRedEyeOutlined';
import DatePicker from 'react-datepicker2';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref,
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
function PaperComponent(props: PaperProps) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}
const editIcon: IIconProps = { iconName: 'Edit' };
const deleteIcon: IIconProps = { iconName: 'Delete' };
let allItems: IArtworkGridRowItem[] = [];
let allEventItems: IEventItem[] = [];


const wrapperClass = mergeStyles({
  padding: 2,
  selectors: {
    '& > .ms-Shimmer-container': {
      margin: '10px 0',
    },
  },
});
const shimmerWithElementFirstRow = [
  { type: ShimmerElementType.circle, height: 24 },
  { type: ShimmerElementType.gap, width: '2%' },
  { type: ShimmerElementType.line, height: 16 }

];
enum enumDialogMode {
  Create,
  Update,
  FinalApprove,
  View
}
type pageProps =
  IUserState &
  typeof actionCreators &
  RouteComponentProps;

interface PageState {
  showComponenrt: boolean;
  title_s: string;
  // ------ 
  Id: number;
  CompanyTitle: string;
  ArtUrl: string;
  MediaName: string;
  ReleaseDate: any;
  EventStartDateMiladi: any;
  EventEndDateMilad: any;
  EventStartDate: string;
  EventEndDate: string;
  EventSectionId: number;
  EventId: any;
  ArtTemplateId: number;
  SpecialPrize: boolean;
  showAddEditDialog: boolean;
  fullWidth: boolean;
  showMessage: boolean;
  message: string;
  msgType: AlertColor;
  loading: boolean;
  isInSearchMode: boolean;
  isDataLoaded: boolean;
  formItems: IArtworkGridRowItem[];
  EventItems: IEventItem[];
  lstEvents: IComboBoxItem[];
  selectionFiles: IFileItem[];
  selectionFileNames: string;
  DialogTitle: string,
  DialogMode: enumDialogMode
}
const EventSections: IComboBoxItem[] = [
  { id: 1, label: "رسانه های مکتوب و دیجیتال" },
  { id: 2, label: "رسانه های دیداری و شنیداری" }
]
const ArtTemplates: IComboBoxItem[] = [
  { id: 1, label: "خبر" },
  { id: 2, label: "گزارش" },
  { id: 3, label: "گفتگو" },
  { id: 4, label: "تیتر" },
  { id: 5, label: "یادداشت، مقاله، سرمقاله" }
]



interface AutoCompleteOptionType {
  inputValue?: string;
  label: string;
  id: number;
}
const filter = createFilterOptions<AutoCompleteOptionType>();
class RequestDemo extends React.PureComponent<pageProps, PageState> {

  constructor(props) {
    super(props);
    this.state = {
      showComponenrt: false,
      title_s: "",
      Id: 0,
      CompanyTitle: "",
      ArtUrl: "",
      MediaName: "",
      ReleaseDate: momentJalaali(),
      EventStartDate: "",
      EventStartDateMiladi: null,
      EventEndDateMilad: null,
      EventEndDate: "",
      ArtTemplateId: 1,
      EventId: null,
      EventSectionId: 1,
      SpecialPrize: false,
      selectionFiles: [],
      selectionFileNames: "",
      showMessage: false,
      message: "",
      loading: false,
      isInSearchMode: false,
      msgType: "info",
      formItems: [],
      lstEvents: [],
      EventItems: [],
      isDataLoaded: true,
      showAddEditDialog: false,
      fullWidth: false,
      DialogMode: enumDialogMode.Create,
      DialogTitle: ""
    };
  }
  async CheckPermission() {
   
    this.setState({ showComponenrt: true, });
  }
  logOut() {
    this.props.logoutAction();
    this.props.history.push({
      pathname: '/login',
      search: '?ref=Registration',
      state: { detail: "response.data" }
    });
  }
  public async componentDidMount() {
     
    this.CheckPermission();


  }
  formatTime(num) {
    return String(num).replace(".", " : ");
  }

  getEventSectionTitle(eventSectione) {
    switch (eventSectione) {
      case 1:
        return EventSections[0].label;
      case 2:
        return EventSections[1].label;

      default:
        return "";
    }
  }
  getArtTemplateTitle(artTemplate) {
    if (artTemplate > 0 && artTemplate <= ArtTemplates.length)
      return ArtTemplates[artTemplate - 1].label;
    return "";
  }


  handelEventSectionSelect = event => {
    this.setState({ EventSectionId: event.target.value });
  };
  handelEventSelect = event => {
    this.setState({ EventId: event.target.value });
    let events = this.state.EventItems.filter(x => x.Id === event.target.value);
    if (events.length > 0) {
      this.setState({ EventStartDate: events[0].ArtworkStartDate, EventEndDate: events[0].ArtworkEndDate });
    }
  };
  handelArtTemplateSelect = event => {
    this.setState({ ArtTemplateId: event.target.value });
  };

  async AddNewItem() {
    try {
      const selectedFileIds = this.state.selectionFiles.map(({ fileId }) => fileId);
      const data = await dalService.create(this.state.EventId, this.state.CompanyTitle, this.state.MediaName, this.state.ReleaseDate, this.state.EventSectionId,
        this.state.ArtTemplateId, this.state.ArtUrl, this.state.SpecialPrize, selectedFileIds);
      if (data !== null) {
        this.setState({
          msgType: MuiMessageBarType.success,
          showMessage: true,
          message: "با موفقیت ثبت شد",
          loading: false,
          Id: data,
          showAddEditDialog: false
        });
  
      }
    }
    catch (ex) {
      this.HandleException(ex);
    }
  }


  async AddNewFileItem(file: IFileItem) {
    try {
      const data = await dalService.uploadfile(file);
      if (data !== null) {
        return data
      }
    }
    catch (ex) {
      this.HandleException(ex);
    }
  }
  async DeleteFileItem(fileGuid: any) {
    try {
      let data = {};
      if (!UtilityService.isNullOrEmpty(fileGuid))
        data = await dalService.deleteFile(fileGuid);
      if (data !== null) {
        let sf = this.state.selectionFiles;
        sf.splice(sf.findIndex(e => e.fileGuid === fileGuid), 1);
        let sfn = this.state.selectionFiles.map(x => x.dataFiles.name).join(" , ");//.substring(0, 30)
        this.setState({ selectionFiles: sf, selectionFileNames: sfn });
        return data
      }
    }
    catch (ex) {
      this.HandleException(ex);
    }
  }
  handleFileSelect = async (e) => {
    let fileObj = {} as IFileItem;
    if (e.target.files.length > 0) {
      fileObj.dataFiles = e.target.files[0];
      fileObj.url = URL.createObjectURL(e.target.files[0]);
      fileObj.fileId = 0;
      fileObj.fileGuid = "";
      let sf = this.state.selectionFiles;
      sf.push(fileObj);
      this.setState({ selectionFiles: sf });
      this.forceUpdate();
      let data = await this.AddNewFileItem(fileObj.dataFiles);
      if (data != undefined) {
        fileObj.fileId = data.id;
        fileObj.fileGuid = data.fileGuid;
        let indexToUpdate = sf.findIndex(item => item.dataFiles === fileObj.dataFiles);
        sf[indexToUpdate] = fileObj;
        let sfn = this.state.selectionFiles.map(x => x.dataFiles.name).join(" , ");
        this.setState({ selectionFiles: sf, selectionFileNames: sfn });
      }
      else {
        let indexToUpdate = sf.findIndex(item => item.dataFiles === fileObj.dataFiles);
        sf.splice(indexToUpdate, 1);
        this.setState({ selectionFiles: sf });
        this.forceUpdate();
      }

    }
  }
  handleFileRemove = (fileGuid) => {
    if (this.state.selectionFiles.length > 0) {
      this.setState({ loading: true });
      this.DeleteFileItem(fileGuid);
      this.setState({ loading: false });
    }
  }
  handleArtTitleChange = e => { this.setState({ CompanyTitle: e.target.value }); };
  handleMediaNameChange = e => { this.setState({ MediaName: e.target.value }); };
  handleArtUrlChange = e => { this.setState({ ArtUrl: e.target.value }); };
  handleMediaNameChange3 = e => { if ((UtilityService.isNumberOrEmpty(e.target.value)) && (e.target.value.length < 12)) this.setState({ MediaName: e.target.value }); };
  handleSeoRegistrationNoChange = e => { this.setState({ ArtTemplateId: e.target.value }); };
  handletitle_s_Change = e => { this.setState({ title_s: e.target.value }); };
  handleSpecialPrize = event => {
    this.setState({ SpecialPrize: event.target.checked })

  }
  handleButtonSubmitClick = () => {
    if (!this.formIsValid())
      return;
    this.setState({
      loading: true
    });
    switch (this.state.DialogMode) {
      case enumDialogMode.Create:
        this.AddNewItem();
        break;
      case enumDialogMode.Update:
 
        break;
      default:
        break;
    }
  };


  handleButtonAddNewClick = () => {

    this.setState({
      Id: 0,
      CompanyTitle: "",

      ArtTemplateId: 0,
      EventSectionId: 0,
      MediaName: "",

      selectionFiles: [],
      selectionFileNames: "",

      showAddEditDialog: true,
      message: "",
      showMessage: false,
      DialogMode: enumDialogMode.Create,
      DialogTitle: "  ثبت اثر  "
    });
  }
  handleAddEditDialogClick = e => { this.setState({ showAddEditDialog: e.target.value }); };
  handleMessageDialogClick = e => { this.setState({ showMessage: e.target.value }); };
  private formIsValid(): boolean {
    let vm = "";
    let isModelValid = true;



    if (this.state.CompanyTitle === "") {
      vm += "\n";
      vm += "لطفا نام اثر را وارد نمایید";
      isModelValid = false;
      this.setState({
        showMessage: !isModelValid,
        msgType: MuiMessageBarType.error,
        message: vm
      });
      return isModelValid;
    }
    if (this.state.MediaName === "") {
      vm += "\n";
      vm += "لطفا نام رسانه را وارد نمایید";
      isModelValid = false;
      this.setState({
        showMessage: !isModelValid,
        msgType: MuiMessageBarType.error,
        message: vm
      });
      return isModelValid;
    }

    this.setState({
      showMessage: !isModelValid,
      msgType: MuiMessageBarType.error,
      message: vm
    });
    return isModelValid;
  }

  GetPersianDate(mDate: Date) {
    if (mDate) {
      return momentJalaali(mDate).format('jYYYY/jMM/jDD');
    }
    return "";
  }
  GetMiladiDate(sDate: any) {
    if (!UtilityService.isNullOrEmpty(sDate)) {
      return momentJalaali(sDate);
    }
    return null;
  }

  HandleException(ex) {
    const err = (ex as any).response;
    var msg = "";
    if (err) {

      if (err.data) {
        if (err.data.title) {
          msg += err.data.title;
          msg += "\n ";
        }
        if (err.data.detail)
          msg += err.data.detail;
      }
      if (err.status === 500) {
        this.setState({
          showMessage: true,
          message: "درخواست با خطا مواجه گردید، لطفا دقایقی بعد مجددا تلاش فرمایید",
          msgType: MuiMessageBarType.error,
          loading: false
        });
        return;
      }
      if (err.status === 400) {
        this.setState({
          showMessage: true,
          message: msg,
          msgType: MuiMessageBarType.error,
          loading: false
        });
        return;
      }
      if (err.status === 404) {
        this.setState({
          showMessage: true,

          message: msg,
          msgType: MuiMessageBarType.error,
          loading: false
        });
        return;
      }
      if (err.status === 403 || err.status === 401) {
        this.setState({
          showMessage: true,
          message: "شما مجاز به انجام این عمل نمی باشید",
          msgType: MuiMessageBarType.error,
          loading: false
        });
        return;
      }
      if (err.message === "Network Error") {
        msg += "\n";
        msg += "لطفا از اتصال سیستم به شبکه اطمینان حاصل فرمایید"
      }
    }
    if (UtilityService.isNullOrEmpty(msg))
      msg = "درخواست با خطا مواجه گردید، لطفا دقایقی بعد مجددا تلاش فرمایید";

    this.setState({
      message: msg,
      showMessage: true,
      msgType: MuiMessageBarType.error,
      loading: false,
      isDataLoaded: true
    });
    this.setState({
      showMessage: true,
      message: msg,
      msgType: MuiMessageBarType.error,
      loading: false
    });
  }
  public render() {
    return (
      <div  >
        {!this.state.showComponenrt ?
          <LoadingSpinner />
          :
          <React.Fragment>
            <div className='container-fluid' >
              <div className='app-layout' >

   
             
          
                         
                              <Row>
                                <Col >
                                  <label htmlFor="lbln" className='labelFor' > <b>     نام شرکت: <span className='spanR'>*</span></b> 
                                  </label>   <br></br>
                                  <TextField dir='ltr' label='' fullWidth={true} value={this.state.CompanyTitle} name="lblUn" onChange={this.handleArtTitleChange} />
                                </Col>
                              </Row>
                              <Row>
                                <Col >
                                  <label htmlFor="lblm" className='labelFor' > <b>   اثر در کدام رسانه منتشر شده است؟ <span className='spanR'>*</span></b> </label>   <br></br>
                                  <TextField dir='ltr' label='' fullWidth={true} value={this.state.MediaName} name="lblUn" onChange={this.handleMediaNameChange} />
                                </Col>
                              </Row>
                              <Row>
                                <Col xs="12" sm="12" md="6" lg="6" xl="4">

                                  <label htmlFor="lbld" className='labelFor' > <b>   تاریخ انتشار:  </b> </label>   <br></br>

                                  <DatePicker
                                    timePicker={false}
                                    isGregorian={false}
                                    min={this.state.EventStartDateMiladi}
                                    max={this.state.EventEndDateMilad}
                                    value={this.state.ReleaseDate}
                                    onChange={ReleaseDate => this.setState({ ReleaseDate })}
                                  />
                                </Col>
                                <Col >
                                  <p className='hint' style={{ marginTop: '45px', textAlign: "center" }}>
                                    بازه انتشار از
                                    &nbsp;

                                    {this.state.EventStartDate}
                                    &nbsp;
                                    تا
                                    &nbsp;
                                    {this.state.EventEndDate}
                                    &nbsp;
                                    می باشد.





                                  </p>
                                </Col>

                              </Row>
                              <Row>
                                <Col >
                                  <label htmlFor="combo-box-es" className='labelFor' > <b> مربوط به کدام بخش از جشنواره می باشد؟    :  <span className='spanR'>*</span></b> </label>
                                  <Select id='combo-box-es' dir='rtl' style={{ width: "100%", padding: "0px" }}
                                    value={this.state.EventSectionId}
                                    onChange={this.handelEventSectionSelect}
                                    inputProps={{
                                      name: "label",
                                      id: "Id"
                                    }}
                                  >
                                    {EventSections.map(x => (
                                      <MenuItem key={"name-shared" + x.id} value={x.id}>
                                        {x.label}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </Col>

                                <Col xs="12" sm="12" md="6" lg="5" xl="4">
                                  <label htmlFor="combo-box-t" className='labelFor' > <b>قالب اثر  :  <span className='spanR'>*</span></b> </label>
                                  <Select id='combo-box-t' dir='rtl' style={{ width: "100%", padding: "0px" }}
                                    value={this.state.ArtTemplateId}
                                    onChange={this.handelArtTemplateSelect}
                                    inputProps={{
                                      name: "label",
                                      id: "Id"
                                    }}
                                  >
                                    {ArtTemplates.map(x => (
                                      <MenuItem key={"name-shared" + x.id} value={x.id}>
                                        {x.label}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </Col>

                              </Row>


                              <Row hidden={this.state.DialogMode == enumDialogMode.View}>
                                <Col>

                                  <label className='labelFor' >
                                    <b >بارگذاری فایل

                                      <b> ویدئو</b> یا  <b> صدای ضبط شده</b> اثر
                                    </b>
                                  </label>
                                  :
                                  <br></br>
                                  <label>
                                    (برای فایل های ویدیویی و یا صوتی با حجم بالاتر از 100 مگابایت لطفا ابتدا در آپارات آپلود نمایید و سپس لینک آن را در بخش ذیل وارد نمایید)



                                  </label>



                                  <label htmlFor="filePicker" className='filePicker'>
                                    <span  >
                                      <input id="filePicker" className='filePickerInput' type={"file"} accept=".mpeg,.mp4,.mp3,.ogg,.wav" onChange={this.handleFileSelect} required ></input>
                                      {
                                        UtilityService.isNullOrEmpty(this.state.selectionFileNames) ?
                                          "  برای انتخاب فایل کلیک نمایید ..." :
                                          this.state.selectionFileNames
                                      }
                                    </span>
                                  </label>
                                </Col>
                              </Row>

                 
                              <Row>
                                <Col  >
                                  <label htmlFor="lblUt" > <b>  آدرس اثر در رسانه ها و یا فضای مجازی : </b> </label> <br></br>

                                  <TextField required id='lblUt'
                                    value={this.state.ArtUrl}
                                    onChange={this.handleArtUrlChange}
                                    fullWidth

                                  />
                                </Col>
                              </Row>
                       
                    
                              <Row>
                                <Col>
                                  <div className='right' hidden={this.state.DialogMode == enumDialogMode.View} style={{ marginTop: "30px" }}>
                                    {/* disabled={!this.formIsValid() || this.props.loading} */}
                                    <button type="button" disabled={
                                      this.state.loading || (this.state.Id < 0 && !this.state.SpecialPrize)}
                                      style={{ marginLeft: "5px", marginRight: "5px" }}
                                      hidden={this.state.DialogMode == enumDialogMode.FinalApprove}
                                      className="btn btn-primary"
                                      onClick={this.handleButtonSubmitClick}>
                                      {this.state.Id > 0 ? "ویرایش" : "ثبت اطلاعات"}
                                    </button>
                                    &nbsp;&nbsp;

                                    &nbsp;&nbsp;

                                    <button type="button" style={{ marginLeft: "5px", marginRight: "5px" }}
                                      className="btn btn-danger"
                                      onClick={() => this.setState({ showAddEditDialog: false, showMessage: false, loading: false })} >
                                      بازگشت</button>
                                    &nbsp;&nbsp;
                                    <br></br>
                                    {this.state.loading && this.state.showAddEditDialog ? <Spinner label="لطفا منتظر بمانید..." /> : ""}
                                  </div>

                                </Col>
                              </Row>
                          
             
                  <Row>
                    <Col>
                      <Snackbar open={this.state.showMessage && !UtilityService.isNullOrEmpty(this.state.message)} autoHideDuration={appConfigs.MessageHideTime}
                        onClose={() => this.setState({ showMessage: false })}
                        anchorOrigin={MessagePossition} >
                        <Alert onClose={() => this.setState({ showMessage: false })} severity={this.state.msgType} sx={{ width: '100%' }}>
                          {this.state.message}
                        </Alert>
                      </Snackbar>
                    </Col>
                  </Row>
               

              </div>
            </div>
          </React.Fragment>
        }
      </div>
    );
  }
};
export default withRouter(connect((state: IAppState) => state.UserState, actionCreators)(RequestDemo as any));
